<nz-form-item>
  <nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType ?? ''" [nzErrorTip]="errorMessage">
    <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
      <input nz-input [id]="code" [(ngModel)]="value" (change)="inputChanged()" (keyup)="inputTyped()"
        [readOnly]="disabled" [placeholder]="title" autocomplete="off" [attr.maxlength]="maxLength"
        [disabled]="disabled" />
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" nzSearch (click)="openSearch()"><i class="{{searchIcon}}"></i></button>
      </ng-template>
    </nz-input-group>
  </nz-form-control>
</nz-form-item>